import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import SelectPaginate from 'app/shared/components/select-paginate/SelectPaginate';
import { IDeviceTruckImplement } from 'app/shared/model/device-truck-implement.model';
import { ISensorHardware } from 'app/shared/model/sensor-hardware.model';
import { ISensor } from 'app/shared/model/sensor.model';
import React, { useEffect, useState } from 'react';
import { Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { Link, RouteComponentProps } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button, Col, Row } from 'reactstrap';
import { createEntity, getEntity, reset, updateEntity } from './device-sensor.reducer';

export const DeviceSensorUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);
  const [sensor, setSensor] = useState<ISensor>(null);
  const [deviceTruckImplement, setDeviceTruckImplement] = useState<IDeviceTruckImplement>(null);
  const [sensorHardwareEquation, setSensorHardwareEquation] = useState<ISensorHardware>(null);
  const [deviceSensor, setDeviceSensor] = useState<ISensor | any>(null);

  const deviceSensorEntity = useAppSelector(state => state.deviceSensor.entity);
  const loading = useAppSelector(state => state.deviceSensor.loading);
  const updating = useAppSelector(state => state.deviceSensor.updating);
  const updateSuccess = useAppSelector(state => state.deviceSensor.updateSuccess);

  const handleClose = () => {
    props.history.push('/device-sensor' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...deviceSensorEntity,
      ...values,
      sensor,
      deviceTruckImplement,
      sensorHardware: sensorHardwareEquation?.id ? sensorHardwareEquation : null,
    };

    if (!entity?.sensor?.id) {
      return toast.error('Necessário selecionar um sensor.');
    }

    if (!entity?.deviceTruckImplement?.id) {
      return toast.error('Necessário selecionar um equipamento instalado.');
    }

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  useEffect(() => {
    if (deviceSensorEntity && !isNew) {
      setSensorHardwareEquation(deviceSensorEntity?.sensorHardware);
      setSensor(deviceSensorEntity?.sensor);
      setDeviceTruckImplement(deviceSensorEntity?.deviceTruckImplement);
    }
  }, [deviceSensorEntity]);

  useEffect(() => {
    deviceSensorEntity &&
      setDeviceSensor({
        ...deviceSensorEntity,
        sensorId: deviceSensorEntity?.sensor?.id,
        sensorHardwareId: deviceSensorEntity?.sensorHardware?.id,
        deviceTruckImplementId: deviceSensorEntity?.deviceTruckImplement?.id,
      });
  }, [deviceSensorEntity]);

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fleetSenseApp.deviceSensor.home.createOrEditLabel" data-cy="DeviceSensorCreateUpdateHeading">
            <Translate contentKey="fleetSenseApp.deviceSensor.home.createOrEditLabel">Create or edit a DeviceSensor</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={deviceSensor} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="device-sensor-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                  className="d-none"
                />
              ) : null}
              <ValidatedField
                label={translate('fleetSenseApp.deviceSensor.hardwareKey')}
                id="device-sensor-hardwareKey"
                name="hardwareKey"
                required
                data-cy="hardwareKey"
                type="text"
              />
              <div className="mb-3">
                <label>{translate('fleetSenseApp.deviceSensor.sensor')}</label>
                <SelectPaginate value={sensor} apiUrl="api/allSensorsListWithPagination" onChange={setSensor} valueName="name" isRequired />
              </div>
              <div className="mb-3">
                <label>{translate('fleetSenseApp.sensorHardware.equation')}</label>
                <SelectPaginate value={sensorHardwareEquation} apiUrl="api/sensor-hardwares" onChange={setSensorHardwareEquation} valueName="description" />
              </div>
              <div className="mb-3">
                <label>{translate('fleetSenseApp.deviceSensor.deviceTruckImplement')}</label>
                <SelectPaginate
                  value={deviceTruckImplement}
                  apiUrl="api/device-truck-implements"
                  onChange={setDeviceTruckImplement}
                  valueName="serial"
                  searchName='serialSearch'
                  isRequired
                />
              </div>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/device-sensor" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DeviceSensorUpdate;
